import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Instructions from "./pages/Instructions";
import EnterCode from "./pages/EnterCode";
import ExamPage from "./pages/ExamPage";
import ResultPage from "./pages/ResultPage";
import Header from "./components/Header";
import Signup from "./pages/Signup";   
import Login from "./pages/Login";  
import Courses from "./pages/Courses";   
import Internships from "./pages/Internships";
import Gallery from "./pages/Gallery";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import FAQ from "./pages/FAQ";
import Footer from "./components/Footer";
import "./App.css";
import ForgotPassword from "./pages/ForgotPassword";
import WhatsappPanel from "./whatsapp/WhatsappPanel";

// 🔥 Wrapper to control Header
function Layout() {
  const location = useLocation();

  // ❌ routes where header should NOT show
  const hideHeaderRoutes = ["/login", "/signup", "/exam","/forgot-password","/whatsapp-panel"];

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/enter-code" element={<ProtectedRoute><EnterCode /></ProtectedRoute>}/>
        <Route path="/internships" element={<Internships />} />
        <Route path="/exam" element={<ProtectedRoute><ExamPage /></ProtectedRoute>}/>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
        <Route path="/result" element={<ResultPage />} />
        <Route path="/whatsapp-panel" element={<WhatsappPanel />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
      </Routes>
      {!shouldHideHeader && <Footer />} 
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;